import { AxiosInstance } from 'axios';
import { parseEvents } from './utils';
import { EventsStatusEnum, EventsData, PromiseEventsData } from './types';

export const getEventsData = (api: AxiosInstance) => ({
  getEvents: async (params: any): Promise<PromiseEventsData> => {
    const { data } = await api.get<EventsData>(EventsStatusEnum.GET_EVENTS, {
      params,
    });
    return { ...data, data: parseEvents(data.data) };
  },
});

export const eventsService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getEventsData(api),
  };
};



// WEBPACK FOOTER //
// ./src/services/api/events/eventsService.ts